const baseUrl = process.env.REACT_APP_BASE_API.trim();

const baseGrapql = `${baseUrl}/graphql`;

export const baseApiFiles = process.env.REACT_APP_BASE_FILE.trim();

export default baseGrapql;
